
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6z74O", function(module, exports) {
/* ContributorsMacroRenderer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $5kjCz = parcelRequire("5kjCz");


var $JbVPK = parcelRequire("JbVPK");


var $bX5uj = parcelRequire("bX5uj");


var $i8KfB = parcelRequire("i8KfB");


var $jMyy4 = parcelRequire("jMyy4");

const $091a88986b4982de$export$942f501e41d4af36 = ({ contentId: contentId, skip: skip, macroParams: macroParams })=>{
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $i8KfB.default), {
        variables: {
            contentId: contentId,
            contentStatus: [
                'current'
            ],
            contributorsMacroParameters: macroParams ?? undefined
        },
        skip: skip,
        fetchPolicy: 'cache-first',
        __callerPackage__: "contributors-macro"
    });
    return {
        data: data?.singleContent?.contributorsMacro ? data : undefined,
        loading: Boolean(loading),
        error: error ?? null
    };
};





const $4e61a88dc657dd37$var$ANONYMOUS_USER_ID = 'anonymous';
const $4e61a88dc657dd37$var$getComparator = (order)=>{
    switch(order){
        case 'name':
            return (a, b)=>a.fullName.localeCompare(b.fullName);
        case 'update':
            return (a, b)=>b.lastActiveTime - a.lastActiveTime;
        case 'edits':
            return (a, b)=>b.edits - a.edits;
        case 'editTime':
            return (a, b)=>b.lastEditTime - a.lastEditTime;
        case 'count':
        default:
            return (a, b)=>b.totalCount - a.totalCount;
    }
};
const $4e61a88dc657dd37$var$hasContributionInIncludedTypes = (contributor, include)=>{
    return include.some((type)=>{
        switch(type){
            case 'authors':
                return contributor.edits > 0;
            case 'comments':
                return contributor.comments > 0;
            case 'labels':
                return contributor.labels > 0;
            case 'watches':
                return contributor.watches > 0;
            default:
                return false;
        }
    });
};
const $4e61a88dc657dd37$export$cf4681f9c9c1bbb6 = (ranking)=>{
    if (!ranking) return [];
    const result = [];
    for (const author of ranking){
        if (author == null) continue;
        const edits = author.edits ?? 0;
        const comments = author.comments ?? 0;
        const labels = author.labels ?? 0;
        const watches = author.watches ?? 0;
        const lastEditTime = author.lastEditTime ?? 0;
        const lastCommentTime = author.lastCommentTime ?? 0;
        const lastLabelTime = author.lastLabelTime ?? 0;
        const lastActiveTime = Math.max(lastEditTime, lastCommentTime, lastLabelTime);
        result.push({
            id: author.idString ?? '',
            fullName: author.fullNameString ?? '',
            totalCount: edits + comments + labels + watches,
            edits: edits,
            comments: comments,
            labels: labels,
            watches: watches,
            lastActiveTime: lastActiveTime,
            lastEditTime: lastEditTime
        });
    }
    return result;
};
const $4e61a88dc657dd37$export$19399e0326061ee2 = ({ data: data, include: include, order: order, reverse: reverse, showAnonymous: showAnonymous, limit: limit })=>{
    return (0, $cozmU.useMemo)(()=>{
        const contentNode = data?.singleContent;
        const authorRankingList = contentNode?.contributorsMacro?.authorRankingList;
        let contributors = $4e61a88dc657dd37$export$cf4681f9c9c1bbb6(authorRankingList ?? null);
        // Filter out anonymous user if not wanted
        if (!showAnonymous) contributors = contributors.filter((c)=>c.id !== $4e61a88dc657dd37$var$ANONYMOUS_USER_ID);
        // Filter by contribution types
        contributors = contributors.filter((c)=>$4e61a88dc657dd37$var$hasContributionInIncludedTypes(c, include));
        // Sort
        const comparator = $4e61a88dc657dd37$var$getComparator(order);
        contributors.sort(reverse ? (a, b)=>comparator(b, a) : comparator);
        // Split into visible and hidden
        const noLimit = limit <= -1;
        let visibleContributors;
        let hiddenContributors;
        if (!noLimit && limit < contributors.length) {
            visibleContributors = contributors.slice(0, limit);
            hiddenContributors = contributors.slice(limit);
        } else {
            visibleContributors = contributors;
            hiddenContributors = [];
        }
        return {
            visibleContributors: visibleContributors,
            hiddenContributors: hiddenContributors
        };
    }, [
        data,
        include,
        order,
        reverse,
        showAnonymous,
        limit
    ]);
};



var $f21pt = parcelRequire("f21pt");




const $20212570a886ccb2$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    showMoreTooltip: {
        id: "contributors-macro.show-more-tooltip",
        defaultMessage: "{count, plural, one {Show # more contributor} other {Show # more contributors}}"
    },
    showMoreLabel: {
        id: "contributors-macro.show-more-label",
        defaultMessage: "{count, plural, one {# more...} other {# more...}}"
    },
    noContributorsDefault: {
        id: "contributors-macro.no-contributors-default",
        defaultMessage: "No contributors found for: {includeTypes} on selected page(s)"
    },
    errorPreview: {
        id: "contributors-macro.error-preview",
        defaultMessage: "{macroLabel} will be shown when you save your edit"
    },
    errorUnsupportedContent: {
        id: "contributors-macro.error-unsupported-content",
        defaultMessage: "{macroLabel} can only be used in pages, blog posts and comments"
    },
    error: {
        id: "contributors-macro.error",
        defaultMessage: "We\u2019re unable to display the contributors. Refresh to try again"
    },
    macroLabel: {
        id: "contributors-macro.label",
        defaultMessage: "Contributors"
    },
    lastActiveTime: {
        id: "contributors-macro.last-active-time",
        defaultMessage: "({time})"
    }
});


/* FlatLayout.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $1l0kj = parcelRequire("1l0kj");

/* ContributorItem.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $7vK9E = parcelRequire("7vK9E");








var $eZ4zi = parcelRequire("eZ4zi");


const $5688b5b2217a5458$var$styles = {
    anchor: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8"
};
const $5688b5b2217a5458$export$c4b574419b8155b = ({ contributor: contributor, showCount: showCount, showTime: showTime })=>{
    const profileUrl = `/wiki/display/~${contributor.id}`;
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        as: "span",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        testId: `contributor-link-${contributor.id}`,
        href: profileUrl,
        target: "_blank",
        xcss: $5688b5b2217a5458$var$styles.anchor
    }, contributor.fullName), showCount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        testId: `contributor-count-${contributor.id}`
    }, contributor.totalCount), showTime && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        testId: `contributor-time-${contributor.id}`
    }, intl.formatMessage((0, $20212570a886ccb2$export$a7357cdd1f0b0168).lastActiveTime, {
        time: (0, $eZ4zi.getRelativeTime)(contributor.lastActiveTime, intl)
    })));
};


/* ShowMoreButton.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");








const $0e08c8f74fde79b1$var$styles = {
    root: "_2sNsIgOLYo _3hxITiYbGa _24h04i2Njc _034jHtYbGa _0KLXrujOvk _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _0wOv4Q7zJH _1ubuxonXvL _34b3D2FQfX _1NDpvb6wH8 _2wtOC9vc3e"
};
const $0e08c8f74fde79b1$export$e41c325c8b11c297 = ({ hiddenCount: hiddenCount, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const values = {
        count: hiddenCount
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
        type: "button",
        "data-testid": "contributors-show-more",
        onClick: onClick,
        title: formatMessage((0, $20212570a886ccb2$export$a7357cdd1f0b0168).showMoreTooltip, values),
        className: (0, $hekY6.default)([
            $0e08c8f74fde79b1$var$styles.root
        ])
    }, formatMessage((0, $20212570a886ccb2$export$a7357cdd1f0b0168).showMoreLabel, values));
};


const $961a6dfcb49cfabe$var$styles = {
    listSeparator: "_1ANEUSZYee"
};
const $961a6dfcb49cfabe$export$672b5f7bc032ce43 = ({ visibleContributors: visibleContributors, hiddenContributors: hiddenContributors, showCount: showCount, showTime: showTime })=>{
    const [showHidden, setShowHidden] = (0, $cozmU.useState)(false);
    const intl = (0, $kSwu1.useIntl)();
    const handleShowMore = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        setShowHidden(true);
    }, [
        setShowHidden
    ]);
    const renderContributor = (contributor)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5688b5b2217a5458$export$c4b574419b8155b), {
            key: contributor.id,
            contributor: contributor,
            showCount: showCount,
            showTime: showTime
        });
    const listItems = visibleContributors.map(renderContributor);
    if (hiddenContributors.length > 0) {
        if (showHidden) listItems.push(...hiddenContributors.map(renderContributor));
        else listItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0e08c8f74fde79b1$export$e41c325c8b11c297), {
            key: "contributors-show-more",
            hiddenCount: hiddenContributors.length,
            onClick: handleShowMore
        }));
    } // Separators between items come from the locale's CLDR list patterns (Intl.ListFormat)
    // rather than a standalone translatable string, so each locale gets correct punctuation.
    const parts = intl.formatListToParts(listItems, {
        type: 'unit'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        as: "span",
        testId: "contributors-flat-layout",
        alignBlock: "baseline",
        shouldWrap: true
    }, parts.map((part, index)=>part.type === 'literal' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            key: `separator-${index}`,
            xcss: $961a6dfcb49cfabe$var$styles.listSeparator
        }, part.value) : part.value));
};


/* ListLayout.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $dinVW = parcelRequire("dinVW");



const $29376cf569006e15$var$styles = {
    list: "_0LQT5ENHnM"
};
const $29376cf569006e15$export$cacbb3924155d68e = ({ visibleContributors: visibleContributors, hiddenContributors: hiddenContributors, showCount: showCount, showTime: showTime })=>{
    const [showHidden, setShowHidden] = (0, $cozmU.useState)(false);
    const handleShowMore = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        setShowHidden(true);
    }, [
        setShowHidden
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        as: "ul",
        xcss: $29376cf569006e15$var$styles.list,
        testId: "contributors-list-layout"
    }, visibleContributors.map((contributor)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
            key: contributor.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5688b5b2217a5458$export$c4b574419b8155b), {
            contributor: contributor,
            showCount: showCount,
            showTime: showTime
        }))), hiddenContributors.length > 0 && !showHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0e08c8f74fde79b1$export$e41c325c8b11c297), {
        hiddenCount: hiddenContributors.length,
        onClick: handleShowMore
    })), showHidden && hiddenContributors.map((contributor)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
            key: contributor.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5688b5b2217a5458$export$c4b574419b8155b), {
            contributor: contributor,
            showCount: showCount,
            showTime: showTime
        }))));
};


const $003fae4a0b54ead2$var$styles = {
    container: "_3iDTPbvbI6"
};
const $003fae4a0b54ead2$var$ContributorsMacroRendererComponent = ({ macroDefaultProps: macroDefaultProps, macroParams: macroParams })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { contentId: contentId, extensionKey: extensionKey, mode: macroMode, node: node } = macroDefaultProps;
    const attributes = macroDefaultProps.attributes ?? (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    const experienceName = (0, $5kjCz.getExperienceName)(macroMode, node);
    const { include: include, order: order, reverse: reverse, limit: limit, mode: mode, showAnonymous: showAnonymous, showCount: showCount, showTime: showTime, noneFoundMessage: noneFoundMessage, macroParamsForQuery: macroParamsForQuery } = (0, $f21pt.useParsedMacroParams)(macroParams);
    const { data: data, error: error, loading: loading } = (0, $091a88986b4982de$export$942f501e41d4af36)({
        contentId: macroDefaultProps.contentId,
        macroParams: macroParamsForQuery
    });
    const { visibleContributors: visibleContributors, hiddenContributors: hiddenContributors } = (0, $4e61a88dc657dd37$export$19399e0326061ee2)({
        data: data,
        include: include,
        order: order,
        reverse: reverse,
        showAnonymous: showAnonymous,
        limit: limit
    });
    if (loading) return null;
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JbVPK.MacroExperienceFailure), {
        name: experienceName,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: macroMode,
        attributes: attributes,
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }));
    if (!data || visibleContributors.length === 0 && hiddenContributors.length === 0) {
        const message = noneFoundMessage || formatMessage((0, $20212570a886ccb2$export$a7357cdd1f0b0168).noContributorsDefault, {
            includeTypes: include.join(', ')
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
            name: experienceName,
            contentId: contentId,
            extensionKey: extensionKey,
            mode: macroMode,
            attributes: attributes
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "contributors-empty-state"
        }, message));
    }
    const LayoutComponent = mode === 'list' ? (0, $29376cf569006e15$export$cacbb3924155d68e) : (0, $961a6dfcb49cfabe$export$672b5f7bc032ce43);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: experienceName,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: macroMode,
        attributes: attributes
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $003fae4a0b54ead2$var$styles.container,
        testId: "contributors-macro",
        "data-fabric-macro": macroDefaultProps?.attributes?.macroId,
        "data-macro-body": ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LayoutComponent, {
        visibleContributors: visibleContributors,
        hiddenContributors: hiddenContributors,
        showCount: showCount,
        showTime: showTime
    })));
};
const $003fae4a0b54ead2$var$renderErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $20212570a886ccb2$export$a7357cdd1f0b0168).error);
const $003fae4a0b54ead2$export$bdd5e2945207ab45 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        renderOnError: $003fae4a0b54ead2$var$renderErrorFallback,
        attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($003fae4a0b54ead2$var$ContributorsMacroRendererComponent, props));
};
module.exports["ContributorsMacroRenderer"] = $003fae4a0b54ead2$export$bdd5e2945207ab45;

});

parcelRegister("JbVPK", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $98aa426b73cdcfeb$export$e394c7ce8301e00f({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, error: error, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
            name: name,
            attributes: {
                ...attributes,
                source: source
            },
            error: error
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        error,
        mode,
        name,
        source
    ]);
    return children;
}
module.exports["MacroExperienceFailure"] = $98aa426b73cdcfeb$export$e394c7ce8301e00f;

});

parcelRegister("i8KfB", function(module, exports) {
/**
 * @generated SignedSource<<ec07190fb98e0f971c23bf5f1ea3300a>>
 * @relayHash ca950652c375632e8e3242fc2e8e313a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d88382e64959d1d1b6df52cae90f2de3c6d19c72e1d6376f573e550ea308fff3
const $2e401621b9e1fde0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentStatus"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contributorsMacroParameters"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "contentStatus"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "contributorsMacroParameters",
                            "variableName": "contributorsMacroParameters"
                        }
                    ],
                    "concreteType": "ConfluenceContributorsRankings",
                    "kind": "LinkedField",
                    "name": "contributorsMacro",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceAuthorRanking",
                            "kind": "LinkedField",
                            "name": "authorRankingList",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "idString"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "fullNameString"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "edits"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "comments"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "labels"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "watches"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "lastEditTime"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "lastCommentTime"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "lastLabelTime"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContributorsDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContributorsDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "ca950652c375632e8e3242fc2e8e313a",
            "id": "d88382e64959d1d1b6df52cae90f2de3c6d19c72e1d6376f573e550ea308fff3",
            "metadata": {},
            "name": "useContributorsDataQuery",
            "operationKind": "query",
            "text": "query useContributorsDataQuery($contentId:ID,$contentStatus:[String],$contributorsMacroParameters:ConfluenceContributorsMacroParametersModel){singleContent(id:$contentId,status:$contentStatus){id,contributorsMacro(contributorsMacroParameters:$contributorsMacroParameters){authorRankingList{idString,fullNameString,edits,comments,labels,watches,lastEditTime,lastCommentTime,lastLabelTime}}}}"
        }
    };
}();
$2e401621b9e1fde0$var$node.hash = "2b1ea1963eb971919228dd0de7168930";
var $2e401621b9e1fde0$export$2e2bcd8739ae039 = $2e401621b9e1fde0$var$node;
module.exports["default"] = $2e401621b9e1fde0$export$2e2bcd8739ae039;

});

parcelRegister("f21pt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $66904c9443eb5472$export$8bf632d40c0a848b = (value)=>{
    if (!value) return [
        'authors'
    ];
    return value.split(',').map((s)=>s.trim());
};
const $66904c9443eb5472$export$4c17d9c0cb17e4cf = (value)=>{
    const validOrders = [
        'count',
        'name',
        'update',
        'edits',
        'editTime'
    ];
    if (value && validOrders.includes(value)) return value;
    return 'count';
};
const $66904c9443eb5472$export$3fb54149990fb5b5 = (value)=>{
    return value === 'true';
};
const $66904c9443eb5472$export$a122018e819bbb5 = (value)=>{
    if (!value) return -1;
    const parsed = parseInt(value, 10);
    return isNaN(parsed) ? -1 : Math.max(parsed, -1);
};
const $66904c9443eb5472$export$8f0d03faf499ec50 = (macroParams)=>{
    const reverse = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.reverse?.value);
    const showAnonymous = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.showAnonymous?.value);
    return {
        include: macroParams?.include?.value,
        order: macroParams?.order?.value,
        reverse: reverse,
        showAnonymous: showAnonymous,
        page: macroParams?.page?.value,
        labels: macroParams?.labels?.value,
        label: macroParams?.label?.value,
        spaces: macroParams?.spaces?.value,
        space: macroParams?.space?.value,
        contentType: macroParams?.contentType?.value,
        publishDate: macroParams?.publishDate?.value,
        scope: macroParams?.scope?.value
    };
};
const $66904c9443eb5472$export$2f9066b0466085e = (macroParams)=>{
    return (0, $cozmU.useMemo)(()=>{
        const include = $66904c9443eb5472$export$8bf632d40c0a848b(macroParams?.include?.value);
        const order = $66904c9443eb5472$export$4c17d9c0cb17e4cf(macroParams?.order?.value);
        const reverse = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.reverse?.value);
        const limit = $66904c9443eb5472$export$a122018e819bbb5(macroParams?.limit?.value);
        const mode = macroParams?.mode?.value === 'list' ? 'list' : 'inline';
        const showAnonymous = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.showAnonymous?.value);
        const showCount = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.showCount?.value);
        const showTime = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.showLastTime?.value);
        const noneFoundMessage = macroParams?.noneFoundMessage?.value;
        const macroParamsForQuery = $66904c9443eb5472$export$8f0d03faf499ec50(macroParams);
        return {
            include: include,
            order: order,
            reverse: reverse,
            limit: limit,
            mode: mode,
            showAnonymous: showAnonymous,
            showCount: showCount,
            showTime: showTime,
            noneFoundMessage: noneFoundMessage,
            macroParamsForQuery: macroParamsForQuery
        };
    }, [
        macroParams
    ]);
};
module.exports["composeMacroParamsForQuery"] = $66904c9443eb5472$export$8f0d03faf499ec50;
module.exports["useParsedMacroParams"] = $66904c9443eb5472$export$2f9066b0466085e;

});

parcelRegister("eZ4zi", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $dce38ffecfe5cc1b$var$MINUTE = 60000;
const $dce38ffecfe5cc1b$var$HOUR = 3600000;
const $dce38ffecfe5cc1b$var$DAY = 86400000;
const $dce38ffecfe5cc1b$var$WEEK = 604800000;
const $dce38ffecfe5cc1b$var$MONTH = 2592000000;
const $dce38ffecfe5cc1b$var$YEAR = 31536000000;
const $dce38ffecfe5cc1b$export$5a00511f040384d7 = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit'
});
const $dce38ffecfe5cc1b$export$406508d2ca449bd = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
});
const $dce38ffecfe5cc1b$export$d2d0bf9c4d577e53 = (0, $kSwu1.defineMessages)({
    justNow: {
        id: "macro-utils.relative-time-just-now",
        defaultMessage: "just now"
    },
    minutesAgo: {
        id: "macro-utils.relative-time-minutes-ago",
        defaultMessage: "{minuteCount, plural, one {{minuteCount} minute ago} other {{minuteCount} minutes ago}}"
    },
    hoursAgo: {
        id: "macro-utils.relative-time-hours-ago",
        defaultMessage: "{hourCount, plural, one {{hourCount} hour ago} other {{hourCount} hours ago}}"
    },
    daysAgo: {
        id: "macro-utils.relative-time-days-ago",
        defaultMessage: "{dayCount, plural, one {{dayCount} day ago} other {{dayCount} days ago}}"
    },
    weeksAgo: {
        id: "macro-utils.relative-time-weeks-ago",
        defaultMessage: "{weekCount, plural, one {{weekCount} week ago} other {{weekCount} weeks ago}}"
    },
    monthsAgo: {
        id: "macro-utils.relative-time-months-ago",
        defaultMessage: "{monthCount, plural, one {{monthCount} month ago} other {{monthCount} months ago}}"
    },
    yearsAgo: {
        id: "macro-utils.relative-time-years-ago",
        defaultMessage: "{yearCount, plural, one {{yearCount} year ago} other {{yearCount} years ago}}"
    },
    justAMomentAgo: {
        id: "macro-utils.relative-time-just-a-moment-ago",
        defaultMessage: "just a moment ago"
    },
    lessThanAMinuteAgo: {
        id: "macro-utils.relative-time-less-than-a-minute-ago",
        defaultMessage: "less than a minute ago"
    },
    aMinuteAgo: {
        id: "macro-utils.relative-time-a-minute-ago",
        defaultMessage: "a minute ago"
    },
    contentReportMinutesAgo: {
        id: "macro-utils.content-report-minutes-ago",
        defaultMessage: "{minuteCount, plural, one {{minuteCount} minute ago} other {{minuteCount} minutes ago}}"
    },
    aboutAnHourAgo: {
        id: "macro-utils.relative-time-about-an-hour-ago",
        defaultMessage: "about an hour ago"
    },
    contentReportHoursAgo: {
        id: "macro-utils.content-report-hours-ago",
        defaultMessage: "{hourCount, plural, one {about {hourCount} hour ago} other {about {hourCount} hours ago}}"
    },
    yesterdayAt: {
        id: "macro-utils.relative-time-yesterday-at",
        defaultMessage: "yesterday at {time}"
    }
});
const $dce38ffecfe5cc1b$var$formatBucketMessage = (bucket, diffMs, intl)=>{
    if (bucket.valueName && bucket.unitMs) {
        const count = bucket.countCalculator ? bucket.countCalculator(diffMs) : Math.floor(diffMs / bucket.unitMs);
        return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53[bucket.message], {
            [bucket.valueName]: count
        });
    }
    return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53[bucket.message]);
};
const $dce38ffecfe5cc1b$export$bfc1ce7d5853041b = {
    buckets: [
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$MINUTE,
            message: 'justNow'
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$HOUR,
            message: 'minutesAgo',
            valueName: 'minuteCount',
            unitMs: $dce38ffecfe5cc1b$var$MINUTE
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$DAY,
            message: 'hoursAgo',
            valueName: 'hourCount',
            unitMs: $dce38ffecfe5cc1b$var$HOUR
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$WEEK,
            message: 'daysAgo',
            valueName: 'dayCount',
            unitMs: $dce38ffecfe5cc1b$var$DAY
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$MONTH,
            message: 'weeksAgo',
            valueName: 'weekCount',
            unitMs: $dce38ffecfe5cc1b$var$WEEK
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$YEAR,
            message: 'monthsAgo',
            valueName: 'monthCount',
            unitMs: $dce38ffecfe5cc1b$var$MONTH
        },
        {
            maxDiffMs: Number.POSITIVE_INFINITY,
            message: 'yearsAgo',
            valueName: 'yearCount',
            unitMs: $dce38ffecfe5cc1b$var$YEAR
        }
    ]
};
const $dce38ffecfe5cc1b$export$409646d2c0c56892 = {
    buckets: [
        {
            maxDiffMs: 4000,
            message: 'justAMomentAgo'
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$MINUTE,
            message: 'lessThanAMinuteAgo'
        },
        {
            maxDiffMs: 2 * $dce38ffecfe5cc1b$var$MINUTE,
            message: 'aMinuteAgo'
        },
        {
            maxDiffMs: 50 * $dce38ffecfe5cc1b$var$MINUTE,
            message: 'contentReportMinutesAgo',
            valueName: 'minuteCount',
            unitMs: $dce38ffecfe5cc1b$var$MINUTE,
            countCalculator: (diffMs)=>Math.round(diffMs / $dce38ffecfe5cc1b$var$MINUTE)
        },
        {
            maxDiffMs: 90 * $dce38ffecfe5cc1b$var$MINUTE,
            message: 'aboutAnHourAgo'
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$DAY,
            message: 'contentReportHoursAgo',
            valueName: 'hourCount',
            unitMs: $dce38ffecfe5cc1b$var$HOUR,
            countCalculator: (diffMs)=>Math.round(diffMs / $dce38ffecfe5cc1b$var$HOUR)
        }
    ],
    specialCase: ({ timestampMs: timestampMs, nowMs: nowMs, diffMs: diffMs, intl: intl })=>{
        const savedTime = new Date(timestampMs);
        const now = new Date(nowMs);
        if ($dce38ffecfe5cc1b$export$221990270ebfe867(savedTime, now) && diffMs > 5 * $dce38ffecfe5cc1b$var$HOUR) return $dce38ffecfe5cc1b$export$fc16bfc40f160b09(savedTime, intl);
        return null;
    },
    fallback: ({ timestampMs: timestampMs })=>$dce38ffecfe5cc1b$export$359f3c271cd167e3(new Date(timestampMs))
};
const $dce38ffecfe5cc1b$export$e22324fe17cb0dfe = (timestamp, intl, config)=>{
    const nowMs = Date.now();
    const diffMs = nowMs - timestamp;
    if (config.specialCase) {
        const specialResult = config.specialCase({
            timestampMs: timestamp,
            nowMs: nowMs,
            diffMs: diffMs,
            intl: intl
        });
        if (specialResult !== null) return specialResult;
    }
    for (const bucket of config.buckets){
        if (diffMs < bucket.maxDiffMs) return $dce38ffecfe5cc1b$var$formatBucketMessage(bucket, diffMs, intl);
    }
    if (config.fallback) return config.fallback({
        timestampMs: timestamp,
        nowMs: nowMs,
        diffMs: diffMs,
        intl: intl
    });
    return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.justNow);
};
const $dce38ffecfe5cc1b$export$493c11ff22f45a24 = (timestamp, intl)=>{
    const now = Date.now();
    const diff = now - timestamp;
    if (diff < $dce38ffecfe5cc1b$var$MINUTE) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.justNow);
    else if (diff < $dce38ffecfe5cc1b$var$HOUR) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.minutesAgo, {
        minuteCount: Math.floor(diff / $dce38ffecfe5cc1b$var$MINUTE)
    });
    else if (diff < $dce38ffecfe5cc1b$var$DAY) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.hoursAgo, {
        hourCount: Math.floor(diff / $dce38ffecfe5cc1b$var$HOUR)
    });
    else if (diff < $dce38ffecfe5cc1b$var$WEEK) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.daysAgo, {
        dayCount: Math.floor(diff / $dce38ffecfe5cc1b$var$DAY)
    });
    else if (diff < $dce38ffecfe5cc1b$var$MONTH) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.weeksAgo, {
        weekCount: Math.floor(diff / $dce38ffecfe5cc1b$var$WEEK)
    });
    else if (diff < $dce38ffecfe5cc1b$var$YEAR) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.monthsAgo, {
        monthCount: Math.floor(diff / $dce38ffecfe5cc1b$var$MONTH)
    });
    else return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.yearsAgo, {
        yearCount: Math.floor(diff / $dce38ffecfe5cc1b$var$YEAR)
    });
};
const $dce38ffecfe5cc1b$export$221990270ebfe867 = (date, now)=>{
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    return yesterday.toLocaleDateString() === date.toLocaleDateString();
};
const $dce38ffecfe5cc1b$export$fc16bfc40f160b09 = (date, intl)=>{
    return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.yesterdayAt, {
        time: $dce38ffecfe5cc1b$export$5a00511f040384d7.format(date)
    });
};
const $dce38ffecfe5cc1b$export$359f3c271cd167e3 = (date)=>{
    return $dce38ffecfe5cc1b$export$406508d2ca449bd.format(date);
};
const $dce38ffecfe5cc1b$export$505b35374c01d686 = (timestamp, intl)=>{
    return $dce38ffecfe5cc1b$export$e22324fe17cb0dfe(timestamp, intl, $dce38ffecfe5cc1b$export$409646d2c0c56892);
};
module.exports["getRelativeTime"] = $dce38ffecfe5cc1b$export$493c11ff22f45a24;
module.exports["formatContentReportEpochTime"] = $dce38ffecfe5cc1b$export$505b35374c01d686;

});


//# sourceMappingURL=ContributorsMacroRenderer.76013a96.js.map
